import EvaluationESIIScreen from "./EvaluationESIIScreen";
import EvaluationSummaryScreen from "./EvaluationSummaryScreen";
import { FormLoader } from "../../../utils/Loader";

const EvaluationScreen = (props) => {
  const { isFetching, activityHistoryAllInfo } = props;

  if (isFetching) {
    return (
      <div className="text-center">
        <FormLoader width={800} />
      </div>
    );
  }

  if (!activityHistoryAllInfo) {
    return <div className="p-3 text-center">No data available</div>;
  }

  const dashboard =
    activityHistoryAllInfo?.dashboardactivitybyid?.[0]?.dashboard;
  return dashboard === "ESII" ? (
    <EvaluationESIIScreen {...props} />
  ) : (
    <EvaluationSummaryScreen {...props} />
  );
};

export default EvaluationScreen;
